export default {
  toggleSlideShow ({state, dispatch, commit}, artworks = {}) {
    commit('toggleSlideShow')
    commit('updateArtworks', artworks)
    commit('updateCurrentArtwork', 0)
    document.body.style.overflow = state.isToggle ? 'hidden' : 'auto'
  },

  nextArtwork ({state, dispatch, commit}) {
    commit('updateCurrentArtwork', (state.artworkCounter + 1))
  },

  previousArtwork ({state, dispatch, commit}) {
    commit('updateCurrentArtwork', (state.artworkCounter - 1))
  }
}
